import api from './apiClient';

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const basePath = `${BASE_URL}/api/v1/expenses/trips-foreign`;

export default {
  getList(params: any) {
    return api.post(`${basePath}/list`, params).then((res: any) => res.data);
  },
  getById(uuid: string) {
    return api.get(`${basePath}/${uuid}`).then((res: any) => res.data);
  },
  create(data: any) {
    return api.post(`${basePath}/create`, data).then((res: any) => res.data);
  },
  save(data: any) {
    return api.put(`${basePath}/save`, data).then((res: any) => res.data);
  },
  deleteById(uuid: string) {
    return api.delete(`${basePath}/${uuid}`).then((res: any) => res.data);
  },
  download(uuid: string) {
    return api.get(`${basePath}/${uuid}/download`, { responseType: 'blob' });
  }
};
